/* global alert */

import React, { useEffect, useState } from 'react';
import ModalComponentNoButton from './ModalComponentNoButton';
import { Form } from 'react-bootstrap';
import AddressInputs from './AddressInputs';
import { bool, func, object } from 'prop-types';

export default function AccountEditAddressModal({ show, setShow = () => {}, mailingAddress, onUpdate = () => { } }) {
    const [mailingAddressInputs, setMailingAddressInputs] = useState({});
    const [initialInputs, setInitialInputs] = useState({});
    const editMailingAddress = async () => {
        try {
            if (!mailingAddress.id) 
                return;
            const validatedInputs = Object.assign({}, mailingAddressInputs);
            for (const key of Object.keys(validatedInputs)) {
                if (validatedInputs[key] === '') {
                    delete validatedInputs[key];
                }
            }
            const response = await fetch(process.env.APP_URL + `api/mailingAddresses/${mailingAddress.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(Object.assign(
                    {},
                    validatedInputs,
                    {
                        Country: undefined,
                        State: undefined,
                        countryCode: mailingAddressInputs.Country?.countryCode,
                        stateCode: mailingAddressInputs.State?.stateCode,
                    })),
            });
            const data = await response.json();
            if (data.error) {
                throw new Error(data.error);
            }
            if (!data.mailingAddress)
                throw new Error('Address not updated');
            onUpdate();
        } catch (e) {
            alert(e.message);
            console.error(e);
        }
    };
    useEffect(() => {
        if (mailingAddress) {
            setInitialInputs(Object.assign(
                {},
                mailingAddress,
                {
                    countryCode: mailingAddress.Country?.countryCode,
                    stateCode: mailingAddress.State?.stateCode,
                }));
        } else {
            setInitialInputs({});
        }
    }, [mailingAddress]);
    return (<ModalComponentNoButton
        modalTriggerText={'Edit Mailing Address'}
        modalTitle={'Edit Mailing Address'}
        handleSave={() => editMailingAddress()}
        show={show}
        setShow={setShow}
    >
        <Form
            onSubmit={(e) => {
                e.preventDefault();
                editMailingAddress();
            }}>
            <AddressInputs
                initialValues={initialInputs}
                setAddressInputs={setMailingAddressInputs} />
        </Form>
    </ModalComponentNoButton>);
}

AccountEditAddressModal.propTypes = {
    show: bool,
    setShow: func,
    mailingAddress: object,
    onUpdate: func,
};

AccountEditAddressModal.defaultProps = {
    show: false,
};